export default "__VITE_ASSET__Do43Xk0N__"